<script>
// import NavBar from '@components/nav-bar.vue'
import baseMixin from '@mixins/baseMixin'
import OutstandingInvoiceAlert from '@/components/invoices/outstanding-invoice-alert.vue'
import TheDebugBar from '@components/dev/the-debug-bar.vue'
import TheTopBar from '@components/layout/the-top-bar.vue'
import TheImpersonateBar from '@/components/impersonate/the-impersonate-bar.vue'

export default {
  components: {
    OutstandingInvoiceAlert,
    TheDebugBar,
    TheTopBar,
    TheImpersonateBar,
  },
  mixins: [baseMixin],
  props: {
    noGutters: {
      type: Boolean,
    },
  },
  computed: {
    compXAxisPadding() {
      switch (true) {
        case this.isLarge:
        case this.isMedium:
          return 'px-8'
        case this.isSmallOrLower:
          return 'px-2'
        default:
          return ''
      }
    },
  },
}
</script>

<template>
  <v-app id="client-login">
    <TheDebugBar />
    <TheImpersonateBar />
    <TheTopBar hide-drawer @toggleDrawer="drawer = !drawer" />

    <!-- Top navbar divider -->
    <v-divider class="opacity-4"></v-divider>
    <v-main>
      <v-container
        :class="['fill-height', compXAxisPadding]"
        :fluid="isLargeOrLower"
        style="margin-bottom: 100px"
      >
        <v-layout justify-center>
          <v-flex xs12 sm12 md12>
            <OutstandingInvoiceAlert />
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
